//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/Builder.js";
let d=[[[0,"ByDatumMovable",1,0],[0,"ByDatumTargetLabel",1,0],[0,"ByDatumTargetType",1,0],[0,"ByHeight",1,0],[0,"ByInnerDiameter",1,0],[0,"ByOuterDiameter",1,0],[0,"ByText",1,0],[0,"ByWidth",1,0],[0,"DatumMovable",1,0],[0,"DatumTargetLabelText",1,0],[0,"DatumTargetType",1,0],[0,"HeightType",1,0],[0,"HeightValue",1,0],[0,"InnerDiameterType",1,0],[0,"InnerDiameterValue",1,0],[0,"OuterDiameterType",1,0],[0,"OuterDiameterValue",1,0],[0,"Text",1,0],[0,"TextType",1,0],[0,"WidthType",1,0],[0,"WidthValue",1,0]],[],[]];
SPLM.Annotations.SearchCriteriaDatumTargetBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.SearchCriteriaDatumTargetBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Annotations.SearchCriteriaDatumTargetBuilder.DatumTargetTypes = Object.freeze({
    "Point" : "Point", "Line" : "Line", "Rectangular" : "Rectangular", "Circular" : "Circular", "Annular" : "Annular", "Spherical" : "Spherical", "Cylindrical" : "Cylindrical", "Arbitrary" : "Arbitrary"});

SPLM.Annotations.SearchCriteriaDatumTargetBuilder.DatumTargetMovableOptions = Object.freeze({
    "No" : "No", "Yes" : "Yes"});

export default SPLM;